import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Spin, Typography, Space, Table, Button, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../api/axios';
import { AppDispatch, RootState } from '../../redux/store';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchPackages, syncPackages } from '../../redux/slices/packageSlice';

export function PackagesList() {
  const dispatch = useDispatch<AppDispatch>();
  const { packages, loading } = useSelector((state: RootState) => state.packages);

  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    dispatch(fetchPackages());
  }, [dispatch]);

  const handleSync = async () => {
    setSyncing(true);
    try {
      const result = await dispatch(syncPackages()).unwrap();
      message.success(result);
    } catch (err) {
      message.error(err);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <Spin spinning={syncing} tip="Syncing packages, please wait..." size="large">
      <div style={{ padding: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: 16 }}>
          <Button type="primary" onClick={handleSync} disabled={syncing}>
            Sync Packages
          </Button>
        </div>

        <Table
          rowKey="id"
          loading={loading}
          dataSource={packages}
          columns={[
            { title: 'Name', dataIndex: 'prepaidPackageTemplateName' },
            { title: 'Cost', dataIndex: 'cost', render: (value) => `${value} €` },
            { title: 'Data', dataIndex: 'dataByte', render: (value) => `${value / (1024 * 1024)} MB` },
            { title: 'Period (days)', dataIndex: 'periodDays' },
            { title: 'Deleted', dataIndex: 'deleted', render: (value) => (value ? 'Yes' : 'No') },
          ]}
        />
      </div>
    </Spin>
  );
}